<template>
	<div ref="postGrid" class="dc-post-grid-component-wrapper">
		<header>
			<div class="dc-post-top-left" slot="dc-post-top-left">
				<h2 v-if="title" class="section-title-default">{{ title }}</h2>
				<h3 v-if="subtitle" class="section-subtitle-default">{{ subtitle }}</h3>
			</div>
			<div v-if="filters" class="dc-post-top-right" slot="dc-post-top-right">
				<Filters 
					v-if="currentPaged !== null"
					:filterLabel="label_before_filters"
					:filters="filters"
					:loading="loading"
					:initialModel="initial_model"
					:currentPaged="currentPaged"
					:searchButtonId="searchButtonId"
					:searchFormPlaceholder="search_form_placeholder"
					:gridSettings="grid_settings"
					v-on:results="updateResults"
					v-on:searching="triggerLoading"
					v-on:update-total-pages="updateTotalPages"
					v-on:update-total-posts="updateTotalPosts"
					v-on:update-current-paged="updateCurrentPaged"
					v-on:update-post-grid-min-height="updateMinHeight" />
			</div>
		</header>
		<div
			ref="resultsSection"
			:class="['dc-post-grid-results', 'uses-no-image-card-fallbacks', columnsClass]" 
			slot="dc-post-grid-results">
			<DcPostGridResultsNews 
				v-if="results && grid_layout==='news'"
				:results="results"
				:loading="loading"
				:gridLayout="grid_layout"
				:searchButtonId="searchButtonId"
				:showLoadMore="showLoadMore"
				:currentPaged="currentPaged || null"
				:totalPages="totalPages"
				:totalPosts="totalPosts"
				:usesPagination="usesPagination" 
				:postNavigationType="postNavigationType"
				:endOfResults="endOfResults"
				v-on:update-current-paged="updateCurrentPaged"/>
			<DcPostGridResults 
				v-if="results && grid_layout==='default'"
				:results="results"
				:loading="loading"
				:gridLayout="grid_layout"
				:searchButtonId="searchButtonId"
				:showLoadMore="showLoadMore"
				:currentPaged="currentPaged || null"
				:totalPages="totalPages"
				:totalPosts="totalPosts"
				:usesPagination="usesPagination" 
				:postNavigationType="postNavigationType"
				:endOfResults="endOfResults"
				v-on:update-current-paged="updateCurrentPaged"/>
		</div>
		<footer class="dc-post-grid-footer" slot="dc-post-grid-footer"></footer>
	</div>
</template>

<script>
import { ref } from 'vue'
import DcPostGrid from '@dc-post-grid/layout/DcPostGrid';
import DcPostGridResults from './DcPostGridResults';
import DcPostGridResultsNews from './DcPostGridResultsNews';
import Filters from '@dc-post-grid/layout/FiltersToggleable';
export default {
    setup() {
        const cardContentWrapper = ref()
        const cardContentHoverOverlay = ref()

        return {
            cardContentWrapper,
            cardContentHoverOverlay,
        }
    },
	extends: DcPostGrid,
	components: {
		DcPostGridResults,
		DcPostGridResultsNews,
		Filters
	}
}
</script>
